import { Section } from "./Section";
import { Check, X } from "lucide-react";

interface Props {
  eyebrow: string;
  title: string;
  fitTitle?: string;
  fits: string[];
  noFitTitle?: string;
  noFits: string[];
  tone?: "mint" | "butter";
}

export function FitCheck({
  eyebrow,
  title,
  fitTitle = "Passar er om…",
  fits,
  noFitTitle = "Inte rätt om…",
  noFits,
  tone = "mint",
}: Props) {
  const accent = tone === "mint" ? "text-mint" : "text-butter";
  const accentBg = tone === "mint" ? "bg-mint/15 ring-mint/30" : "bg-butter/15 ring-butter/30";

  return (
    <Section className="bg-surface/40">
      <div className="mx-auto max-w-5xl">
        <div className={`mb-3 text-xs uppercase tracking-[0.18em] ${accent}`}>{eyebrow}</div>
        <h2 className="text-balance text-3xl font-semibold leading-tight md:text-5xl">{title}</h2>

        <div className="mt-10 grid gap-5 md:grid-cols-2">
          <article className="rounded-3xl border border-white/10 bg-surface p-7 md:p-8">
            <div className="flex items-center gap-3">
              <div className={`inline-flex h-9 w-9 items-center justify-center rounded-full ring-1 ${accentBg} ${accent}`}>
                <Check className="h-4.5 w-4.5" strokeWidth={2.5} />
              </div>
              <h3 className="text-lg font-semibold">{fitTitle}</h3>
            </div>
            <ul className="mt-5 space-y-3 text-sm leading-relaxed">
              {fits.map((f) => (
                <li key={f} className="flex items-start gap-2.5">
                  <Check className={`mt-0.5 h-4 w-4 shrink-0 ${accent}`} strokeWidth={2.5} />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </article>

          <article className="rounded-3xl border border-white/10 bg-surface/60 p-7 md:p-8">
            <div className="flex items-center gap-3">
              <div className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-muted-foreground ring-1 ring-white/10">
                <X className="h-4.5 w-4.5" strokeWidth={2.5} />
              </div>
              <h3 className="text-lg font-semibold text-muted-foreground">{noFitTitle}</h3>
            </div>
            <ul className="mt-5 space-y-3 text-sm leading-relaxed text-muted-foreground">
              {noFits.map((f) => (
                <li key={f} className="flex items-start gap-2.5">
                  <X className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground/70" strokeWidth={2.5} />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </article>
        </div>
      </div>
    </Section>
  );
}
